// پروژه‌های بودجه
// همان فرم مشترک پروژه/فعالیت، با فیلتر پروژه
import React from 'react';
import AccountingProject from '../Accounting/AccountingProject';

export default function BudgetProject({ user, onBack }) {
  return <AccountingProject user={user} onBack={onBack} initialType="project" />;
}
